import { isNumber, uid } from 'radash';

import {
    Bus,
    ComponentInstanceValidationError,
    ComponentInstanceValidationErrorType,
    ComponentInstanceValidator,
    isSymmetricalImpedance,
} from 'models';

const busGrounding: ComponentInstanceValidator['validator'] = ({ diagram }) => {
    const errors: ComponentInstanceValidationError[] = [];

    const error = (
        type: ComponentInstanceValidationError['type'],
        payload: ComponentInstanceValidationError['payload'],
    ) => {
        errors.push({
            id: uid(6),
            type,
            level: 'error',
            payload,
        });
    };

    Object.values(diagram.componentInstances).forEach((componentInstance) => {
        if (componentInstance.disabled || componentInstance.componentType !== 'bus') {
            return;
        }

        const { earthing } = componentInstance.specifications.electrical as Partial<Bus['electrical']>;

        if (!earthing || !isSymmetricalImpedance(earthing.configuration)) {
            return;
        }

        const positive = earthing.groundReferences['L+'].impedance.value;
        const negative = earthing.groundReferences['L-'].impedance.value;

        if (!isNumber(positive) || positive <= 0 || !isNumber(negative) || negative <= 0) {
            error(ComponentInstanceValidationErrorType.REQUIRED_CONFIGURATION_BUS_GROUNDING_IMPEDANCE, {
                componentInstance,
            });

            return;
        }

        if (positive !== negative) {
            error(ComponentInstanceValidationErrorType.INVALID_CONFIGURATION_BUS_GROUNDING_SYMMETRY, {
                componentInstance,
            });
        }
    });

    return errors;
};

export { busGrounding };
